import { render, staticRenderFns } from "./GradePaper.vue?vue&type=template&id=3a9e9832&scoped=true&"
import script from "./GradePaper.vue?vue&type=script&lang=js&"
export * from "./GradePaper.vue?vue&type=script&lang=js&"
import style0 from "./GradePaper.vue?vue&type=style&index=0&id=3a9e9832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e9832",
  null
  
)

export default component.exports